export default __webpack_public_path__ + "static/media/mens.6ea51ffe.jpg";